import React, { FC } from 'react';

import { FormControlLabel, FormControlLabelProps, Radio } from '@mui/material';
import { styled } from '@mui/material';
import { alpha } from '@mui/material/styles';

interface RadioButtonProps extends Omit<FormControlLabelProps, 'control'> {}

const RadioButton: FC<RadioButtonProps> = ({ label, ...rest }) => {
  return (
    <StyledFormControlLabel
      data-testid={rest['data-testid']}
      label={label}
      control={<StyledRadio />}
      {...rest}
    />
  );
};

export default RadioButton;

const StyledFormControlLabel = styled(FormControlLabel)`
  &:hover .MuiRadio-root {
    background-color: ${({ theme }) => alpha(theme.palette.common.accent, 0.3)};
  }
`;
const StyledRadio = styled(Radio)`
  transition: background-color 0.3s ease;

  & .MuiSvgIcon-root {
    fill: ${({ theme }) => theme.palette.common.white};
  }

  &.Mui-checked {
    color: ${({ theme }) => theme.palette.common.white};
    animation: scale 0.2s linear alternate-reverse;

    @keyframes scale {
      100% {
        transform: scale(0.85);
      }
    }
  }

  &.Mui-checked .MuiSvgIcon-root {
    fill: ${({ theme }) => theme.palette.common.accentMain};
  }
`;
